import { Fab, ButtonProps, Theme, } from '@mui/material';
import { SxProps } from '@mui/system';
import { ReactNode } from 'react';

export type FloatingActionButtonProps = {
    id?: string;
    children?: any;
    color: ButtonProps["color"];
    iconColor: string;
    disabled?: boolean;
    loading?: boolean;
    Icon?: ReactNode;
    href?: string;
    onClick?: () => void;
    buttonStyle?: SxProps<Theme>;
    size?: "normal" | "compact";
};

export default function FloatingActionButton(props: FloatingActionButtonProps) {

    const { id, children, Icon, color, iconColor, disabled, loading, href, buttonStyle, size, onClick, ...other } = props;

    const buttonDisabled = disabled || loading;

    return (
        <Fab
            id={id}
            disabled={buttonDisabled}
            href={href}
            disableRipple
            sx={{
                ...buttonStyle,
                color: iconColor,
            }}
            color={color}
            onClick={onClick}
            {...other}
        >
            {Icon}
        </Fab>
    );
}
